// extracted by mini-css-extract-plugin
module.exports = {"logoTipoAventura":"FormularioProposta_logoTipoAventura__3lkW8"};